import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import it from "./locales/it.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

export const LOCALES = { it: "it-IT", en: "en-GB", es: "es-ES" };

const stored = typeof window !== "undefined" ? localStorage.getItem("sp_lang") : null;

i18n.use(initReactI18next).init({
  resources: { it: { translation: it }, en: { translation: en }, es: { translation: es } },
  lng: stored || "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

export function setLanguage(code) {
  if (!LANGUAGES.some((l) => l.code === code)) return;
  localStorage.setItem("sp_lang", code);
  i18n.changeLanguage(code);
}

export default i18n;
